import './ConfirmationPrompt.scss'

import { ButtonVariant } from '@here/hds-components'
import { HDSButton } from '@here/hds-react-components'
import React from 'react'

export interface ConfirmationPromptProps {
  modalTitle: string
  modalContent: string
  confirmBtnText: string
  cancelBtnText: string
  onConfirm: (e: MouseEvent) => void
  onCancel: (e: MouseEvent) => void
  confirmBtnVariant?: ButtonVariant | undefined
}

export default function ConfirmationPrompt({
  modalTitle,
  modalContent,
  confirmBtnText,
  cancelBtnText,
  onConfirm,
  onCancel,
  confirmBtnVariant,
}: ConfirmationPromptProps): JSX.Element {
  return (
    <div className="ConfirmationPrompt__overlay">
      <div className="ConfirmationPrompt__container">
        <div className="ConfirmationPrompt">
          <div className="ConfirmationPrompt__header">
            <div className="ConfirmationPrompt__header-title">{modalTitle}</div>
          </div>
          <div className="ConfirmationPrompt__content">
            <span className="ConfirmationPrompt__message">{modalContent}</span>
          </div>
          <div className="ConfirmationPrompt__footer">
            <HDSButton onClick={onConfirm} type="button" variant={confirmBtnVariant} width="100%">
              {confirmBtnText}
            </HDSButton>
            <HDSButton onClick={onCancel} type="button" variant="subtle" width="100%">
              {cancelBtnText}
            </HDSButton>
          </div>
        </div>
      </div>
    </div>
  )
}
